import React, { useEffect, useState } from 'react';
import screenAndStyle from '../../_utils/screen-and-style.js';
import { UpdatePhotoEvents } from '../common/events/event-declarations';
import { builderDispatch } from '../../_utils/ui';
import Modal from '../../_utils/modal';

const DESKTOP_CONTINUE_MSG =
  'Continuing will remove the unavailable sizes from your order.';
const MOBILE_CONTINUE_MSG =
  'Continuing will remove the unavailable sizes and photos from your order.';

export default function InvalidSizesModal() {
  const [invalidSizes, setInvalidSizes] = useState([]);
  const [isOpen, handleIsOpen] = useState(false);
  const [onContinue, setOnContinueCallback] = useState(null);

  useEffect(() => {
    const builderDispatchToken = builderDispatch.register(payload => {
      switch (payload.type) {
        case UpdatePhotoEvents.SHOW_INVALID_SIZES_MODAL:
          setInvalidSizes(payload.invalidSizes);
          openModal();
          setOnContinueCallback(() => payload.onContinue);
          break;
      }
    });

    return () => {
      builderDispatch.unregister(builderDispatchToken);
    };
  }, []);

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    openModal();

    return () => {
      closeModal();
    };
  }, [isOpen]);

  function handleOnContinue() {
    onContinue && onContinue();
    closeModal();
  }

  function openModal() {
    handleIsOpen(true);
  }

  function closeModal() {
    handleIsOpen(false);
  }

  const invalidOptions = invalidSizes.map(size =>
    [size.title, size.options?.finish?.title].filter(Boolean).join(' ')
  );

  return (
    <Modal
      close
      className="prints-builder__invalid-sizes-modal"
      open={isOpen}
      onOpen={openModal}
      onClose={closeModal}
      title={'Are you sure?'}
      maxWidth={486}>
      <>
        <p>
          Some print sizes are not available with these print options (
          {invalidOptions.join(', ')}).
        </p>
        <p>
          {(screenAndStyle.isBootstrapXS() && MOBILE_CONTINUE_MSG) ||
            DESKTOP_CONTINUE_MSG}
        </p>
        <div className="modal-footer">
          <button
            aria-label="close modal"
            className="btn btn-link btn-underline"
            type="button"
            onClick={closeModal}
            data-dismiss="modal">
            Cancel
          </button>
          <button
            aria-label="continue"
            className="btn btn-primary"
            type="button"
            data-dismiss="modal"
            onClick={handleOnContinue}>
            Continue
          </button>
        </div>
      </>
    </Modal>
  );
}
